// お知らせ一覧の初期化
export function initInformation() {
    initShowMoreReadInformation();
}
// 遷移時に非表示になっている既読のお知らせを表示させる
function initShowMoreReadInformation() {
    // お知らせ一覧画面でなければ何もしない
    const informationArticle = document.querySelector("[data-information-article]");
    if (!informationArticle)
        return;
    const showMoreReadInformationButton = informationArticle.querySelector("[data-show-more-read-information-button]");
    if (showMoreReadInformationButton) {
        showMoreReadInformationButton.addEventListener("click", (event) => {
            event.preventDefault();
            const hidedInformationElements = informationArticle.querySelectorAll("[data-read-information]");
            for (const hidedInformationElement of hidedInformationElements) {
                // 全件表示なので雑にarea-hideを取る
                hidedInformationElement.classList.remove("area-hide");
            }
            showMoreReadInformationButton.classList.add("area-hide");
        });
    }
}
